import styled from "styled-components";
import { AccountSwitcherLogo } from "../AccountSwitcherLogo/AccountSwitcherLogo";
import { treeMaxWidth } from "../AccountSwitcherTree/styled";

const listPadding = 16;

export const StyledWrapper = styled.div``;

export const StyledLogo = styled(AccountSwitcherLogo)`
  margin-right: 8px;
`;

export const StyledAccountNameWrapper = styled.div<{
  $hasChildren?: boolean;
  $depth: number;
  $hasAtLeastOneAccountHasChildren: boolean;
}>`
  display: grid;
  grid-template-columns: ${({
    $depth,
    $hasChildren,
    $hasAtLeastOneAccountHasChildren,
  }) =>
    $depth === 1 && !$hasChildren && !$hasAtLeastOneAccountHasChildren
      ? "0 1fr"
      : "40px 1fr"};
  background-color: rgb(255 255 255 / 100%);
  margin: 0 8px 0 ${({ $depth }) => ($depth - 1) * listPadding + 8}px;
  max-width: ${treeMaxWidth}px;
`;

export const StyledAccountName = styled.span`
  display: flex;
  flex-grow: 1;
  align-items: center;
  padding: 8px;
  cursor: pointer;
  border-radius: 8px;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  color: #000;
  user-select: none;
  overflow: hidden;

  &:hover {
    background-color: rgb(248 248 248 / 100%);
  }

  > span {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`;

export const StyledExpander = styled.div<{
  $disable: boolean;
  $isExpand?: boolean;
}>`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  color: ${({ $isExpand }) =>
    $isExpand ? "rgba(0, 0, 0, 1)" : "rgba(146, 146, 146, 1)"};
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: ${({ $disable }) => ($disable ? "none" : "auto")};

  &:hover {
    background-color: rgb(248 248 248 / 100%);
  }

  svg {
    transition: transform 0.15s ease-in-out;
    transform: rotate(${({ $isExpand }) => ($isExpand ? 90 : 0)}deg);
  }
`;

export const StyledCheckMark = styled.div`
  color: rgb(0 102 165 / 100%);
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
`;
